module.exports = __webpack_public_path__ + "static/media/lucky-wheel-img-6.3c74cb5d.png";